import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/salesCopy';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream py-12 sm:py-24" aria-labelledby="faq" data-id="element-26" data-mp="1lazal8l2t7cu">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-27" data-mp="1gcpg7076easa">
        <h2 id="faq" className="font-display text-[1.6rem] font-semibold leading-tight text-ink sm:text-4xl" data-id="element-28" data-mp="1ge8uil99ubrf">
          Preguntas frecuentes
        </h2>

        <div className="mt-7 divide-y divide-ink/10 border-y border-ink/10 sm:mt-10" data-id="element-29" data-mp="291mme4y44h4o">
          {faqs.map((item, index) => {
          const isOpen = openIndex === index;
          return <div key={item.question} data-id="element-30" data-mp="24433usudti6x" data-mpi={index}>
                <h3 data-id="element-31" data-mp="1z25fxlb1dz7n">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-4 py-4 text-left transition-colors duration-150 ease-soft hover:text-rose focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-champagne sm:gap-6 sm:py-5" data-id="element-32" data-mp="1z2nj71w49dp2">
                    <span className="font-display text-[17px] leading-snug text-ink sm:text-xl" data-id="element-33" data-mp="ug9artn22abl">
                      {item.question}
                    </span>
                    {isOpen ? <MinusIcon aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 text-champagne" data-id="element-34" data-mp="khtgjhsqekxv" /> : <PlusIcon aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 text-ink/40" data-id="element-35" data-mp="6r6jrv6j754f" />}
                  </button>
                </h3>
                {isOpen && <p id={`faq-panel-${index}`} className="pb-5 text-[15px] leading-relaxed text-ink/70 sm:pb-6 sm:pr-10 sm:text-base" data-id="element-36" data-mp="bk9dq4f80gl5">
                    {item.answer}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}